import { makeAutoObservable, runInAction } from "mobx";
import { getEmployeeTotalSalary, getEmployeePayroll } from "../services/payroll/getPayroll";
import dayjs from "dayjs";

export default class PayrollStore {
  payrollDataList = null;
  employeePayrolls = null;
  payrollData = null;
  employeePayrolData= null;
  loading = false;
  error = null;

  durationIn = null
  durationOut = null

  isPreModalVisible = false;
  isModalVisible = false;

  isEmployeePayrollModal = null;

  isAdjustBtn = false;

  employeePayrollBreakdown = [];

  constructor() {
    makeAutoObservable(this);
  }

  setEmployeePayrollBreakdown = (data) => {
    runInAction(() => {
      this.employeePayrollBreakdown = data?.employeePayrollItems || [];
    });
  };

  updateEmployeePayrollAdjustments = (employeeId, employeePayrollId, adjustments) => {
    // Update the payroll data in the store
    if (this.employeePayrolData?.employeePayrolls) {
      const updatedPayrolls = this.employeePayrolData.employeePayrolls.map(payroll => {
        if (payroll.id === employeePayrollId) {
          const updatedAdjustments = adjustments.map(adj => ({
            ...adj,
            employeeId,
            employeePayrollId
          }));
          
          //const adjustmentTotal = updatedAdjustments.reduce((sum, adj) => sum + adj.amount, 0);
          
          return {
            ...payroll,
            employeePayrollAdjustments: updatedAdjustments,
          };
        }
        return payroll;
      });
  
      this.employeePayrolData = {
        ...this.employeePayrolData,
        employeePayrolls: updatedPayrolls,
        totalSalary: updatedPayrolls.reduce((sum, payroll) => sum + payroll.netPay, 0)
      };
    }
  
    // Also update the payroll list if needed
    if (this.payrollDataList) {
      this.payrollDataList = this.payrollDataList.map(item => {
        if (item.id === employeePayrollId) {
          //const adjustmentTotal = adjustments.reduce((sum, adj) => sum + adj.amount, 0);
          return {
            ...item,
            employeePayrollAdjustments: adjustments.map(adj => ({
              ...adj,
              employeeId,
              employeePayrollId
            })),
            // salaryAdjustment: adjustmentTotal,
            // netPay: item.basicPay + adjustmentTotal
          };
        }
        return item;
      });
    }
  };

  fetchEmployeePayroll = async (
    employeeType,
    startCutoffDate,
    endCutoffDate,
    date,
    search
  ) => {
    this.loading = true;
    this.error = null;

    try {
      const response = await getEmployeeTotalSalary(
        employeeType,
        startCutoffDate,
        endCutoffDate,
        date,
        search
      );
      runInAction(() => {
        this.employeePayrolData = response;
        this.payrollDataList = response?.employeePayrolls;
        this.durationIn = startCutoffDate;
        this.durationOut = endCutoffDate;
        this.loading = false;
      });
    } catch (err) {
      runInAction(() => {
        this.error = err.message || "Failed to fetch payroll data";
        this.loading = false;
      });
    }
  };

  fetchEmployeeIdPayroll = async (
    employeeId,
  ) => {
    this.loading = true;
    this.error = null;

    try {
      const response = await getEmployeePayroll(
        employeeId,
        dayjs(this.durationIn).format("YYYY-MM-DD"),
        dayjs(this.durationOut).format("YYYY-MM-DD"),
      );
      runInAction(() => {
        this.payrollData = response;
        this.employeePayrolls = response?.employeePayrollItems;
        this.loading = false;
      });
    } catch (err) {
      runInAction(() => {
        this.error = err.message || "Failed to fetch payroll data";
        this.loading = false;
      });
    }
  };

  clearPayrollData = () => {
    runInAction(() => {
      this.payrollDataList = null;
    });
  };

  setIsModalVisible = (isVisible) => {
    runInAction(() => {
      this.isModalVisible = isVisible;
    });
  };

  setIsPreModalVisible = (isVisible) => {
    runInAction(() => {
      this.isPreModalVisible = isVisible;
    });
  };
  
  setIsEmployeePayrollModal = (isVisible) => {
    runInAction(() => {
      this.isEmployeePayrollModal = isVisible;
    });
  };

  setIsAdjustBtn = (bool) => {
    runInAction(()=>{
      this.isAdjustBtn = bool;
    })
  }
}
